import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useState, useCallback } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { ExpandMore } from '@mui/icons-material';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import FormAccordionResidence from './form';
import {
  AccordionResidenceVM,
  CohabitationDetailForm,
} from 'cohabitation/view-models/detail-cohabitation';

interface AccordionResidenceProps {
  disabled?: boolean;
  isEditMode?: boolean;
}

const AccordionResidenceComponent = ({
  disabled,
  isEditMode,
}: AccordionResidenceProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  const formContext = useFormikContext<CohabitationDetailForm>();

  const onFieldAccordionResidenceChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('residence', {
        ...formContext.values.residence,
        [key]: value,
      });
    },
    [formContext.values.residence, formContext.setFieldValue]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-residence-content"
        id="panel-person-edit-residence-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Residenza</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <FormAccordionResidence
          disabled={disabled}
          isEditMode={isEditMode}
          values={formContext.values.residence}
          onChange={onFieldAccordionResidenceChange}
          errors={formContext.errors.residence as unknown as FormikErrors<AccordionResidenceVM>}
          touched={formContext.touched.residence as FormikTouched<AccordionResidenceVM>}
        />
      </AccordionDetails>
    </Accordion>
  );
};

AccordionResidenceComponent.displayName = 'Accordion Residence component';

const AccordionResidence = memo(AccordionResidenceComponent);

export default AccordionResidence;
